export const buildUndoDelete = (state, action) =>
  state.map((product) => {
    if (action.ids.indexOf(product.id) > -1) {
      return {
        ...product,
        isDeleted: false,
        isChecked: false,
      };
    }

    return product;
  });
